// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__315rD","unreadBadge":"styles_unreadBadge__31mOW","modalContent":"styles_modalContent__2Gd43","modal":"styles_modal__rSvrn"};